// TelcoTrack — typy pro vygenerovaná workflow data (generated-workflows.ts).
// Drží přesnou strukturu z Excelu: workflow = lineární seznam fází; fáze nese kód
// (WORKFLOWID.PHASE.N), frontend název a barvu pro každý výkres/roli.

import type { ColorKey } from './phase-codes';

export type GeneratedDrawingId = 'general' | 'stavba' | 'montaz' | 'zafuk' | 'optika';

export interface GeneratedPhase {
  /** Pozice fáze ve workflow (0-based). */
  index: number;
  /** Kanonický kód fáze v DB/API: `WORKFLOWID.PHASE.N`. */
  code: string;
  /** Český frontend název fáze (např. „Zavrtaný"). */
  name: string;
  /** Klíč barvy (do PHASE_COLORS) pro každý výkres; null = na tom výkresu se objekt nezobrazuje. */
  colors: Record<GeneratedDrawingId, ColorKey | null>;
}

export interface GeneratedWorkflow {
  /** Workflow ID, např. `BUDOVA.2`. */
  id: string;
  /** Typ objektu (část před první tečkou), např. `BUDOVA`. */
  objectType: string;
  /** Frontend název typu, např. „Budova". */
  frontendName: string;
  /** Lineární seřazené fáze. */
  phases: GeneratedPhase[];
}
